__turbopack_context__.v({
  "--right": "dialog-module__qos6xa__--right",
  "body": "dialog-module__qos6xa__body",
  "button": "dialog-module__qos6xa__button",
  "closeButton": "dialog-module__qos6xa__closeButton",
  "confettiOverlay": "dialog-module__qos6xa__confettiOverlay",
  "dialog": "dialog-module__qos6xa__dialog",
  "foot": "dialog-module__qos6xa__foot",
  "head": "dialog-module__qos6xa__head",
  "headline": "dialog-module__qos6xa__headline",
  "noPadding": "dialog-module__qos6xa__noPadding",
  "scrollWrapper": "dialog-module__qos6xa__scrollWrapper",
  "sticky": "dialog-module__qos6xa__sticky",
  "subHeadline": "dialog-module__qos6xa__subHeadline",
});
